import StackComponent from './StackComponent';
export default StackComponent;
